import "./ClientMedicalDetailsComponent.scss";
import DataLabelValueComponent from "../../../../shared/components/data-label-value/DataLabelValueComponent";
import {CommonService} from "../../../../shared/services";
import {useSelector} from "react-redux";
import {IRootReducerState} from "../../../../store/reducers";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";
import React from "react";
import {useNavigate} from "react-router-dom";
import FormControlLabelComponent from "../../../../shared/components/form-control-label/FormControlLabelComponent";
import CardV2Component from "../../../../shared/components/card-v2/CardV2Component";
import PageHeaderComponent from "../../../../shared/components/page-header/PageHeaderComponent";
import HorizontalLineV2Component from "../../../../shared/components/horizontal-line-v2/HorizontalLineV2Component";

interface ClientMedicalDetailsComponentProps {
}

const ClientMedicalDetailsComponent = (props: ClientMedicalDetailsComponentProps) => {
    const navigate = useNavigate();
    const {
        clientMedicalHistoryDetails,
        clientBasicDetails,
        isClientMedicalHistoryDetailsLoading,
        isClientMedicalHistoryDetailsLoaded,
        isClientMedicalHistoryDetailsLoadingFailed
    } = useSelector((state: IRootReducerState) => state.client);

    return (
        <div className={'client-medical-details-component'}>
            {
                isClientMedicalHistoryDetailsLoading && <div>
                    <LoaderComponent/>
                </div>
            }
            {
                isClientMedicalHistoryDetailsLoadingFailed &&
                <StatusCardComponent title={"Failed to fetch client Details"}/>
            }
            {
                (isClientMedicalHistoryDetailsLoaded && clientMedicalHistoryDetails) && <>
                    <PageHeaderComponent title={'Medical Questionnaire'} className={'pdd-left-10'}/>
                    <CardV2Component title={'Personal Habits'}
                                     showAction={true}
                                     actionTitle={'Edit'}
                                     onClick={() => navigate(CommonService._client.NavigateToClientEdit("personalHabits"))}

                    >
                        <div className={'ts-row mrg-bottom-20'}>
                            <div className={'ts-col-lg-4'}>
                                Smoke/Chew Tobacco?
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Smoke/Chew Tobacco?"]?.value || "N/A"}
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Smoke/Chew Tobacco?"]?.text ? clientMedicalHistoryDetails?.personal_habits?.["Smoke/Chew Tobacco?"]?.text + " Cigarettes/day" : "N/A"}
                            </div>
                        </div>
                        <div className={'ts-row mrg-bottom-20'}>
                            <div className={'ts-col-lg-4'}>
                                Drink Alcohol?
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Drink Alcohol?"]?.value || "N/A"}
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Drink Alcohol?"]?.text ? clientMedicalHistoryDetails?.personal_habits?.["Drink Alcohol?"]?.text + " Drinks/day" : "N/A"}
                            </div>
                        </div>
                        <div className={'ts-row mrg-bottom-20'}>
                            <div className={'ts-col-lg-4'}>
                                Drink Coffee?
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Drink Coffee?"]?.value || "N/A"}
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Drink Coffee?"]?.text ? clientMedicalHistoryDetails?.personal_habits?.["Drink Coffee?"]?.text + " Cups/day" : "N/A"}
                            </div>
                        </div>
                        <div className={'ts-row mrg-bottom-20'}>
                            <div className={'ts-col-lg-4'}>
                                Drink Soda/Pop?
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Drink Soda/Pop?"]?.value || "N/A"}
                            </div>
                            <div className={'ts-col-lg-3'}>
                                {clientMedicalHistoryDetails?.personal_habits?.["Drink Soda/Pop?"]?.text ? clientMedicalHistoryDetails?.personal_habits?.["Drink Soda/Pop?"]?.text + " Cups/day" : "N/A"}
                            </div>
                        </div>
                    </CardV2Component>
                    <HorizontalLineV2Component/>
                    <CardV2Component title={'Allergies'}
                                     showAction={true}
                                     actionTitle={'Edit'}
                                     onClick={() => navigate(CommonService._client.NavigateToClientEdit("allergies"))}
                    >
                        {/*{clientMedicalHistoryDetails?.allergies?.split("\n").map((i: any, key: any) => {*/}
                        {/*    return <li key={key}>{i}</li>;*/}
                        {/*})}*/}
                        <div
                            className={'allergies-na'}> {clientMedicalHistoryDetails?.allergies ? clientMedicalHistoryDetails?.allergies.split("\n").map((i: any, key: any) => {
                            return <li key={key}>{i}</li>;
                        }) : <div className={'allergies-na'}>None Reported</div>}</div>
                    </CardV2Component>
                    <HorizontalLineV2Component/>
                    <CardV2Component title={'Medication/Supplements'}
                                     showAction={true}
                                     actionTitle={'Edit'}
                                     onClick={() => navigate(CommonService._client.NavigateToClientEdit("medicalSupplements"))}

                    >
                        <DataLabelValueComponent label={'Prescription Medications'}>
                            {clientMedicalHistoryDetails?.medications?.prescription_medication ? clientMedicalHistoryDetails?.medications?.prescription_medication.split("\n").map((i: any, key: any) => {
                                return <div key={key}>{i}</div>;
                            }) : 'N/A'}
                        </DataLabelValueComponent>
                        <DataLabelValueComponent label={'Non-Prescription Medications / Supplements'}>
                            {clientMedicalHistoryDetails?.medications?.non_prescription_medication ? clientMedicalHistoryDetails?.medications?.non_prescription_medication.split("\n").map((i: any, key: any) => {
                                return <div key={key}>{i}</div>;
                            }) : 'N/A'}
                        </DataLabelValueComponent>
                    </CardV2Component>
                    <HorizontalLineV2Component/>

                    <CardV2Component title={'Medical Provider Information'}
                                     showAction={true}
                                     actionTitle={'Edit'}
                                     onClick={() => navigate(CommonService._client.NavigateToClientEdit("medicalProvider"))}
                    >
                        <div className={'ts-row'}>
                            <div className={'ts-col-lg-5'}>
                                <DataLabelValueComponent label={'Family Doctor Name'}>
                                    {clientMedicalHistoryDetails?.medical_provider_info?.family_doctor_name || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                            <div className={'ts-col-lg-4'}>
                                <DataLabelValueComponent label={'MD Phone'}>
                                    {CommonService.formatPhoneNumber(clientMedicalHistoryDetails?.medical_provider_info?.md_phone) || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                        </div>
                        <div className={'ts-row'}>
                            <div className={'ts-col-lg-5'}>
                                <DataLabelValueComponent label={'Referring Doctor Name'}>
                                    {clientMedicalHistoryDetails?.medical_provider_info?.referring_doctor_name || "N/A"}
                                </DataLabelValueComponent>
                            </div>
                            <div className={'ts-col-lg-4'}>
                                <DataLabelValueComponent label={'MD Phone'}>
                                    {CommonService.formatPhoneNumber(clientMedicalHistoryDetails?.medical_provider_info?.primary_phone) || "N/A"}
                                </DataLabelValueComponent>
                            </div>

                        </div>
                        <div className={'ts-row'}>
                            <div className={'ts-col-lg-6'}>
                                <DataLabelValueComponent label={' Date of Last Physical Examination'}>
                                    {clientMedicalHistoryDetails?.medical_provider_info?.last_examination_date ? CommonService.getSystemFormatTimeStamp(clientMedicalHistoryDetails?.medical_provider_info?.last_examination_date) : "N/A"}
                                </DataLabelValueComponent>
                            </div>
                        </div>
                    </CardV2Component>
                    <HorizontalLineV2Component/>
                    <CardV2Component actionTitle={'Edit'} showAction={true} title={'Medical History'}
                                     onClick={() => navigate(CommonService._client.NavigateToClientEdit("medicalHistory"))}
                    >
                        {
                            (clientMedicalHistoryDetails?.medical_history?.questions_details && clientMedicalHistoryDetails?.medical_history?.questions_details?.length > 0) ?
                                <div className={"mrg-bottom-10"}>
                                    {
                                        clientMedicalHistoryDetails?.medical_history?.questions_details && clientMedicalHistoryDetails?.medical_history?.questions_details?.map((question: any, index: number) => {
                                            return <span key={question?._id + index}>
                                                    <li>{question.title}</li>
                                                {/*{(clientMedicalHistoryDetails?.medical_history?.questions_details && clientMedicalHistoryDetails?.medical_history?.questions_details?.length - 1 !== index) &&*/}
                                                {/*    <span>, </span>*/}
                                                {/*}*/}
                                                </span>
                                        })
                                    }
                                </div> : <>{!clientMedicalHistoryDetails?.medical_history?.comments ?
                                    <div className={'allergies-na'}>None Reported</div> : <></>}</>
                        }
                        {clientMedicalHistoryDetails?.medical_history?.comments && <> <FormControlLabelComponent
                            label={"Other Illnesses/Conditions"}
                            className={'mrg-bottom-10'}/>
                            {clientMedicalHistoryDetails?.medical_history?.comments &&
                                <div className={'mrg-bottom-25'}>
                                    {clientMedicalHistoryDetails?.medical_history?.comments.split("\n").map((i: any, key: any) => {
                                        return <li key={key}>{i}</li>;
                                    })}
                                </div>
                            }
                        </>}
                    </CardV2Component>
                    <HorizontalLineV2Component/>
                    {
                        clientBasicDetails?.gender === "female" && <>
                            <CardV2Component title={'Females Only'} showAction={true} actionTitle={'Edit'}
                                             onClick={() => navigate(CommonService._client.NavigateToClientEdit("medicalFemaleOnly"))}

                            >
                                <div className={'ts-row'}>
                                    <div className={'females-only-block'}>
                                        <div className={'ts-col-lg-10 mrg-bottom-20'}>
                                            <DataLabelValueComponent label={'Pregnant or Attempting to be pregnant?'}
                                                                     direction={'row'}>
                                                {clientMedicalHistoryDetails?.females_only_questions?.["Pregnant or trying to get pregnant?"] || "N/A"}
                                            </DataLabelValueComponent>
                                        </div>
                                        <div className={'ts-col-lg-10'}>
                                            <DataLabelValueComponent label={'Nursing?'} direction={'row'}>
                                                {clientMedicalHistoryDetails?.females_only_questions?.["Nursing?"] || "N/A"}
                                            </DataLabelValueComponent>
                                        </div>
                                    </div>
                                </div>
                            </CardV2Component>
                            <HorizontalLineV2Component className={'mrg-top-15'}/>
                        </>
                    }
                    <CardV2Component title={'Surgical History'}
                                     showAction={true}
                                     actionTitle={'Edit'}
                                     onClick={() => navigate(CommonService._client.NavigateToClientEdit("surgicalHistory"))}

                    >
                        {
                            (clientMedicalHistoryDetails?.surgical_history?.questions_details && clientMedicalHistoryDetails?.surgical_history?.questions_details?.length > 0) ?
                                <div className={"mrg-bottom-10"}>
                                    {
                                        clientMedicalHistoryDetails?.surgical_history?.questions_details?.map((question: any, index: number) => {
                                            return <span key={question?._id + index}>
                                                    <li>{question.title}</li>
                                                </span>
                                        })
                                    }
                                </div> : <>{!clientMedicalHistoryDetails?.surgical_history?.comments ?
                                    <div className={'allergies-na'}>None Reported</div> : <></>}</>
                        }
                        {clientMedicalHistoryDetails?.surgical_history?.comments && <> <FormControlLabelComponent
                            label={"Other Illnesses/Conditions"}
                            className={'mrg-bottom-10'}/>
                            {clientMedicalHistoryDetails?.surgical_history?.comments && <div className={'mrg-bottom-10'}>
                                {clientMedicalHistoryDetails?.surgical_history?.comments.split("\n").map((i: any, key: any) => {
                                    return <li key={key}>{i}</li>;
                                })}
                            </div>
                            }
                        </>}
                    </CardV2Component>
                    <HorizontalLineV2Component />

                    <CardV2Component title={'Musculoskeletal History'}
                                     showAction={true}
                                     actionTitle={'Edit'}
                                     onClick={() => navigate(CommonService._client.NavigateToClientEdit("musculoskeletalHistory"))}

                    >
                        {
                            (Object.keys(clientMedicalHistoryDetails?.musculoskeletal_history || {}).length === 0) &&
                            <div className={'allergies-na'}>None Reported</div>
                        }
                        {
                            (Object.keys(clientMedicalHistoryDetails?.musculoskeletal_history || {}).map((question, index) => {
                                console.log('question', question);
                                return (
                                    <div key={question + index} className={"musculoskeletal-history-block"}>
                                        <div className="ts-row">
                                            <div className="ts-col-5 font-weight-bold  mrg-bottom-10">
                                                {clientMedicalHistoryDetails?.musculoskeletal_history[question]?.client_title}
                                            </div>
                                            <div
                                                className="ts-col-3 font-weight-bold text-primary  mrg-bottom-10">
                                                {clientMedicalHistoryDetails?.musculoskeletal_history[question]?.value ==="Yes" ? "Yes" : "No"}
                                            </div>
                                            <div className="ts-col-4">
                                                {clientMedicalHistoryDetails?.musculoskeletal_history[question]?.text ? (
                                                    <div className={'musculoskeletal-question'}>
                                                        {clientMedicalHistoryDetails?.musculoskeletal_history[question]?.text.split("\n").map((i: any, key: any) => (
                                                            <div key={key}>{i}</div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div className={'musculoskeletal-question-na'}>N/A</div>
                                                )}
                                            </div>
                                        </div>
                                        <HorizontalLineV2Component className={'mrg-top-15'}/>
                                    </div>
                                );
                            }))

                        }
                    </CardV2Component>
                </>
            }
        </div>
    );

};

export default ClientMedicalDetailsComponent;
